import React, { useEffect, useState } from "react";
import { DataItem } from "../datatype";
import customFetch from "../../../API/CustomFetch";
import {
  customer_consent_get_inspection_repair,
  customer_requirement,
} from "../../../API/api";
import ErrorFallback from "../../ErrorFallback/ErrorFallback";
import LeadCardSkeleton from "../../../layouts/spinners/LeadCardSkeleton";

interface ExtraRequirement {
  id: number;
  Requirement: string | null;
  Cost: number | null;
  finalCost: number | null;
  isMandatory: number; // 1 or 0
  isApprovedByCustomer: number | null;
}

interface InspectionRepairProps {
  onDataLoaded?: (success: boolean) => void;
}

const InspectionRepair = ({ onDataLoaded }: InspectionRepairProps) => {
  const [inspect, setInspect] = useState(false);
  const [repair, setRepair] = useState(false);
  const [data, setData] = useState<DataItem[] | null>(null);
  const [extraRequirements, setExtraRequirements] = useState<
    ExtraRequirement[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const typeMasterId = urlParams.get("type");
    if (typeMasterId && parseInt(typeMasterId) === 53) {
      setInspect(true);
    } else if (typeMasterId && parseInt(typeMasterId) === 54) {
      setRepair(true);
    }
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const typeMasterId = urlParams.get("type");
    const vehicleProfileId = urlParams.get("vp");

    if (!typeMasterId || !vehicleProfileId) {
      onDataLoaded?.(false);
      setLoading(false);
      return;
    }

    setLoading(true);

    const url = `${customer_consent_get_inspection_repair}/${vehicleProfileId}/${typeMasterId}`;

    customFetch(url)
      .then((res) => {
        if (res.SUCCESS && Array.isArray(res.DATA)) {
          setData(res.DATA);
          onDataLoaded?.(true);
        } else {
          setData([]);
          onDataLoaded?.(false);
        }
      })
      .catch(() => {
        setData([]);
        onDataLoaded?.(false);
      })
      .finally(() => {
        if (parseInt(typeMasterId) !== 54) {
          setLoading(false);
        } else {
          const extraUrl = `${customer_requirement}/${vehicleProfileId}`;
          customFetch(extraUrl)
            .then((res) => {
              if (res.SUCCESS && Array.isArray(res.DATA)) {
                const subList = res.DATA[0]?.subList || [];
                const filtered = subList.map((item: any) => ({
                  id: item.id,
                  Requirement: item.Requirement,
                  Cost: item.Cost || 0,
                  finalCost: item.finalCost || 0,
                  isMandatory: item.isMandatory ?? 0,
                  isApprovedByCustomer: item.isApprovedByCustomer,
                }));
                setExtraRequirements(filtered);
              }
            })
            .catch(() => setExtraRequirements([]))
            .finally(() => setLoading(false));
        }
      });
  }, []);

  if (loading) {
    return <LeadCardSkeleton height="50vh" />;
  }

  if (!Array.isArray(data) || data.length === 0) {
    return <ErrorFallback message="Inspection or Repair data not available." />;
  }

  const totalRepairCost = data.reduce((total, item) => {
    return (
      total +
      (Array.isArray(item.Question)
        ? item.Question.reduce(
            (subtotal, q) => subtotal + (q.UpdatedCost || 0),
            0,
          )
        : 0)
    );
  }, 0);

  const totalRepairFinalCost = data.reduce((total, item) => {
    return (
      total +
      (Array.isArray(item.Question)
        ? item.Question.reduce(
            (subtotal, q) => subtotal + (q.UpdatedCost || 0),
            0,
          )
        : 0)
    );
  }, 0);

  const totalExtraCost = extraRequirements.reduce(
    (total, req) =>
      req.isApprovedByCustomer === 1 || req.isApprovedByCustomer === null
        ? total + (req.Cost || 0)
        : total,
    0,
  );

  const totalExtraFinalCost = extraRequirements.reduce(
    (total, req) =>
      req.isApprovedByCustomer === 1 || req.isApprovedByCustomer === null
        ? total + (req.finalCost || 0)
        : total,
    0,
  );
  console.log("Repair - ", totalRepairCost, totalRepairFinalCost);
  console.log("Extra ", totalExtraCost, totalExtraFinalCost);
  console.log("data", data);

  // const totalCost = totalRepairCost + totalExtraCost;
  const totalCost = totalExtraCost;

  console.log("Total Cost ", totalCost);
  // const totalFinalCost = totalRepairFinalCost + totalExtraFinalCost;
  const totalFinalCost = totalExtraFinalCost;

  console.log("final Total Cost ", totalFinalCost);

  const imageExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".webp",
    ".bmp",
    ".svg",
    ".tiff",
  ];

  return (
    <div className="border border-gray-200 rounded-xl shadow-md p-6 bg-white">
      <h2 className="text-2xl font-bold mb-6 text-gray-900 text-center">
        {inspect
          ? "Inspection Information"
          : repair
            ? "Repair Criteria Information"
            : ""}
      </h2>

      {/* INSPECTION TABLE */}
      {inspect && (
        <table className="table-auto w-full mb-6">
          <thead>
            <tr>
              <th className="px-4 py-2">Question</th>
              <th className="px-4 py-2">Response</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) =>
              Array.isArray(item.Question)
                ? item.Question.map((q) => {
                    const isImage =
                      typeof q.Response === "string" &&
                      imageExtensions.some((ext) =>
                        q.Response.toLowerCase().split("?")[0].endsWith(ext),
                      );

                    return (
                      <tr key={q.QuestionId}>
                        <td className="border px-4 py-2">{q.Question}</td>
                        <td className="border px-4 py-2">
                          {isImage ? (
                            <img
                              src={q.Response}
                              alt={q.Question}
                              className="max-h-[70vh] rounded border"
                            />
                          ) : (
                            q.Response || "-"
                          )}
                        </td>
                      </tr>
                    );
                  })
                : null,
            )}
          </tbody>
        </table>
      )}

      {/* BASIC REPAIR CARDS */}
      {repair && (
        <div className="mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4">
            Basic Repair Check
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {data.map((item) =>
              Array.isArray(item.Question)
                ? item.Question.map((q) => (
                    <div
                      key={q.QuestionId}
                      className="p-4 border border-gray-400 rounded-lg shadow-sm bg-gray-50"
                    >
                      <p className="font-semibold text-gray-900 text-sm mb-1">
                        {q.Question}
                      </p>
                      <p className="text-gray-700 text-sm">
                        {q.Response || "-"}
                      </p>
                    </div>
                  ))
                : null,
            )}
          </div>
        </div>
      )}

      {/* EXTRA REQUIREMENTS */}
      {repair && (
        <div>
          {extraRequirements.length > 0 ? (
            <>
              {/* Mandatory Requirements */}
              <h3 className="text-xl font-semibold mb-3 text-gray-900">
                Mandatory Requirements
              </h3>

              <div className="overflow-x-auto mb-8 bg-white">
                <table className="w-full table-fixed text-left border-collapse border border-gray-400">
                  <thead className="bg-blue-50 text-blue-900">
                    <tr>
                      <th className="w-1/3 px-4 py-3 font-semibold border border-gray-400 text-center">
                        Requirement
                      </th>
                      <th className="w-1/3 px-4 py-3 font-semibold border border-gray-400 text-center">
                        Cost
                      </th>
                      {/* <th className="w-1/3 px-4 py-3 font-semibold border border-gray-400 text-center">
                        Final Cost
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {extraRequirements
                      .filter(
                        (item) =>
                          item.isMandatory === 1 &&
                          (item.isApprovedByCustomer === 1 ||
                            item.isApprovedByCustomer === null),
                      )
                      .map((item) => (
                        <tr
                          key={item.id}
                          className="hover:bg-gray-50 transition-all"
                        >
                          <td className="border border-gray-400 px-4 py-3">
                            {item.Requirement}
                          </td>
                          <td className="border border-gray-400 px-4 py-3 text-right">
                            ₹{item.Cost}
                          </td>
                          {/* <td className="border border-gray-400 px-4 py-3 text-right">
                            ₹{item.finalCost}
                          </td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {/* Optional Requirements */}
              <h3 className="text-xl font-semibold mb-3 text-gray-900">
                Optional Requirements
              </h3>

              <div className="overflow-x-auto    mb-8 bg-white">
                <table className="w-full table-fixed text-left border-collapse border border-gray-400">
                  <thead className="bg-green-50 text-green-900">
                    <tr>
                      <th className="w-1/3 px-4 py-3 font-semibold border border-gray-400 text-center">
                        Requirement
                      </th>
                      <th className="w-1/3 px-4 py-3 font-semibold border border-gray-400 text-center">
                        Cost
                      </th>
                      {/* <th className="w-1/3 px-4 py-3 font-semibold border border-gray-400 text-center">
                        Final Cost
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {extraRequirements
                      .filter(
                        (item) =>
                          item.isMandatory === 0 &&
                          (item.isApprovedByCustomer === 1 ||
                            item.isApprovedByCustomer === null),
                      )
                      .map((item) => (
                        <tr
                          key={item.id}
                          className="hover:bg-gray-50 transition-all"
                        >
                          <td className="border border-gray-400 px-4 py-3">
                            {item.Requirement}
                          </td>
                          <td className="border border-gray-400 px-4 py-3 text-right">
                            ₹{item.Cost}
                          </td>
                          {/* <td className="border border-gray-400 px-4 py-3 text-right">
                            ₹{item.finalCost}
                          </td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <ErrorFallback message="No additional requirements listed." />
          )}
        </div>
      )}

      {/* TOTAL COST TABLE */}
      {repair && (
        <div className="overflow-x-auto  shadow  mt-4 bg-white">
          <table className="w-full table-fixed text-left border-collapse border border-gray-400">
            <thead className="bg-gray-100 text-gray-900">
              <tr>
                <th className="w-1/3 border border-gray-400 px-4 py-3 font-semibold text-center">
                  Total Cost (Mandatory + Optional)
                </th>
                <th className="w-1/3 border border-gray-400 px-4 py-3 font-semibold text-right">
                  ₹{totalCost}
                </th>
                {/* <th className="w-1/3 border border-gray-400 px-4 py-3 font-semibold text-right">
                  ₹{totalFinalCost}
                </th> */}
              </tr>
            </thead>
          </table>
        </div>
      )}

      {repair && (
        <p className="text-sm italic mt-3 text-black">
          GST will be charged extra as applicable. Labour charges extra.
        </p>
      )}
    </div>
  );
};

export default InspectionRepair;
